import { createRouter, createWebHistory, createMemoryHistory } from "vue-router";
import { useScrollStore } from "@/stores/storeScroll";
import TheHomePage from "@/pages/TheHomePage.vue";
import TheNotFindPage from "@/pages/TheNotFindPage.vue";
import TheProfilePage from "@/pages/TheProfilePage.vue";
import TheQuizWordsPage from "@/pages/TheQuizWordsPage.vue";
import TheQuizMatchesPage from "@/pages/TheQuizMatchesPage.vue";
import TheAboutTelegramPage from "@/pages_telegram/TheAboutTelegramPage.vue";
import TheProfileTelegramPage from "@/pages_telegram/TheProfileTelegramPage.vue";
import ThePrizesTelegramPage from "@/pages_telegram/ThePrizesTelegramPage.vue";
import TheGameMatchesTelegramPage from "@/pages_telegram/TheGameMatchesTelegramPage.vue";
import TheGameWordsTelegramPage from "@/pages_telegram/TheGameWordsTelegramPage.vue";
import TheUploadReceiptTelegramPage from "@/pages_telegram/TheUploadReceiptTelegramPage.vue";
import TheReferralsTelegramPage from "@/pages_telegram/TheReferralsTelegramPage.vue";

const isServer = typeof window === "undefined";

export const routes = [
	{
		path: "/",
		name: "home",
		component: TheHomePage,
	},
	{
		path: "/profile/",
		name: "profile",
		component: TheProfilePage,
		meta: { requiresAuth: true },
	},
	{
		path: "/quiz_words/",
		name: "quiz_words",
		component: TheQuizWordsPage,
		meta: { requiresAuth: true },
	},
	{
		path: "/quiz_matches/",
		name: "quiz_matches",
		component: TheQuizMatchesPage,
		// meta: { requiresAuth: true },
	},
	// мероприятие в Парке Горького завершилось — все его страницы ведут на главную
	{
		path: "/parkgorkogo/test/result/",
		alias: "/parkgorkogo/test/result",
		redirect: "/",
	},
	{
		path: "/parkgorkogo/test/",
		alias: "/parkgorkogo/test",
		redirect: "/",
	},
	{
		path: "/parkgorkogo/",
		alias: "/parkgorkogo",
		redirect: "/",
	},
	{
		path: "/parkgorkogo/:pathMatch(.*)*",
		redirect: "/",
	},
	{
		path: "/:pathMatch(.*)*",
		name: "404",
		component: TheNotFindPage,
	},
	// telegram_bot
	{
		path: "/telegram_bot_about_promo_page/",
		name: "telegram_bot_about_promo_page",
		component: TheAboutTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_profile_page/",
		name: "telegram_bot_profile_page",
		component: TheProfileTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_upload_receipt_page/",
		name: "telegram_bot_upload_receipt_page",
		component: TheUploadReceiptTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_game1_page/",
		name: "telegram_bot_game1_page",
		component: TheGameMatchesTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_game2_page/",
		name: "telegram_bot_game2_page",
		component: TheGameWordsTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_prizes_page/",
		name: "telegram_bot_prizes_page",
		component: ThePrizesTelegramPage,
		// meta: { requiresAuth: true },
	},
	{
		path: "/telegram_bot_referral_system_page/",
		name: "telegram_bot_referral_system_page",
		component: TheReferralsTelegramPage,
		// meta: { requiresAuth: true },
	},
]
export const router = createRouter({
	history: isServer ? createMemoryHistory(import.meta.env.BASE_URL) : createWebHistory(import.meta.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		const storeScroll = useScrollStore();
		const headerOffset = storeScroll.header?.offsetHeight || 100;

		if (to.hash) {
			return {
				el: to.hash,
				behavior: "smooth",
				top: headerOffset,
			};
		}

		if (savedPosition) {
			return savedPosition;
		}
		return { top: 0 };
	},
});

export default router;
